import * as Yup from "yup";

export const supportingDocsValidations = (section, formType, dbFormSpec) => {

 
    let minFileCount = dbFormSpec.idVerification ? parseInt(dbFormSpec.idVerification.numOfDocsExpected || 0) : 0;
    let filesMessage = "Please upload the minimum number of document(s): " + minFileCount;

    if (section.active) {
        return Yup.object().shape({
            supportingDoc: (dbFormSpec.idVerification && minFileCount > 0) && Yup.array()
                .required(
                    () =>
                        'Please upload the required document(s)'
                )
                .test(
                    'file-minimum',
                    filesMessage,
                    function checkIfFilesAreCorrectType(files) {

                        if (files && files.length >= minFileCount ) {
                            return true;
                        }
                        return false;
                    }
                )
                .test(
                    'is-file-big',
                    'Please remove all files larger than 15mb',
                    function checkIfFilesAreCorrectSize(files) {
                        let valid = true
                        if (files) {
                            files.map(file => {
                                if (file.size > 1.5e+7) {
                                    valid = false
                                }
                            })
                        }
                        return valid
                    }
                )
        });
    } else {
        return Yup.object().shape();
    }
};



export const supportingDocsValidationsProxy = (section, formType, dbFormSpec) => {
    if (formType === "Representative") {
        let minFileCountProxy = dbFormSpec.idVerificationProxy ? parseInt(dbFormSpec.idVerificationProxy.numOfDocsExpected || 0):0;
        let filesMessageProxy = "Please upload the minimum number of document(s): " + minFileCountProxy;
        return Yup.object().shape({

            supportingDocProxy: (dbFormSpec.idVerificationProxy && minFileCountProxy > 0) && Yup.array()
                .required(
                    () =>
                        'Please upload the required documents proving authority to act on behalf of the patient'

                )
                .test(
                    'file-limit',
                    section.fields.supportingDoc.validations.fileLimit.message,
                    function checkIfFilesAreCorrectType(files) {

                        if (files) {
                            return files.length <= 4;
                        }
                        return true;
                    }
                )
                .test(
                    'file-minimum',
                    filesMessageProxy,
                    function checkIfFilesAreCorrectType(files) {
                        if (files && files.length >= minFileCountProxy) {
                            return true;
                        }
                        return false;
                    }
                )
                .test(
                    'is-file-big',
                    'Please remove all files larger than 15mb',
                    function checkIfFilesAreCorrectSize(files) {
                        let valid = true
                        if (files) {
                            files.map(file => {
                                if (file.size > 1.5e+7) {
                                    valid = false
                                }
                            })
                        }
                        return valid
                    }
                ),
            documentationProxy: Yup.string()
                .required(
                    () =>
                        true &&
                        "Please choose one of the options"
                )
        });
    } else {
        return Yup.object().shape();
    }
};